<template lang="">
  <div
    class="popover-content"
    ref="container"
  >
    <ms-scrollbar
      v-if="!isEmpty"
      ref="scrollbar"
      @scroll="onScroll"
      max-height="600px"
      wrap-class="el-select-dropdown__wrap"
      view-class="el-select-dropdown__list"
    >
      <notify-item
        v-for="notify in listNotify"
        :key="notify.Id"
        :notify="notify"
        @on-click="onClickItem"
        @show-popup-join-class-fail="showPopupJoinClassFail"
        @show-popup-join-new-class="showPopupJoinNewClass"
      />
      <notify-item
        v-if="isLoading"
        :is-empty="true"
      />
    </ms-scrollbar>
    <slot
      v-else-if="$slots.empty"
      name="empty"
    />
    <data-empty
      v-else
      class="is-empty"
    />
  </div>
</template>

<script>
import BaseList from '@/views/base/base-list.vue'
import NotifyItem from './notify-item'
import MsScrollbar from '@/components/scrollbar'
import DataEmpty from '@/views/pages/common/components/data-empty.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { nextTick } from 'vue'

const studentJoinNewClass = () =>
  import('@/views/pages/student/classroom/popup/student-join-new-class.vue')

export default {
  extends: BaseList,

  emits: ['onClickNotifyItem'],

  components: {
    NotifyItem,
    MsScrollbar,
    DataEmpty
  },

  props: {
    /**
     * Có load data lúc mới tạo hay không
     */
    autoLoadData: {
      type: Boolean,
      default: true
    },

    notUseCommonData: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      autoLoad: false,
      pageIndex: 1,
      pageSize: 20,
      isLastPage: false,
      notifyIsClicked: {},
      isLoading: true,
      notifyItems: [],
      studentJoinNewClass: 'studentJoinNewClass'
    }
  },

  computed: {
    ...mapState('notify', {
      numberNotifyUnPreview: 'numberNotifyUnPreview'
    }),

    /**
     * danh sách thông báo
     */
    listNotify () {
      const me = this

      return me.notUseCommonData
        ? me.notifyItems
        : me.$store.state.notify?.notifies
    },

    /**
     * Không có thông báo
     */
    isEmpty () {
      const me = this

      return !me.isLoading && me.listNotify?.length === 0
    }
  },

  methods: {
    ...mapActions('notify', [
      'getNotify',
      'countNotifyUnPreview',
      'previewNotify'
    ]),
    ...mapMutations('notify', ['setNotifies']),

    /**
     * @override
     */
    getContainer () {
      return this.$refs.container
    },

    /**
     * @description Lấy UI popup
     * @author lhlong
     */
    async getOtherPopup (componentName) {
      const me = this

      switch (componentName) {
        case me.studentJoinNewClass:
          return await studentJoinNewClass()
        default:
          break
      }
    },

    /**
     * @author PVThang
     * @override
     */
    showMask () {
      this.isLoading = true
    },

    /**
     * @author PVThang
     * @override
     */
    async hideMask () {
      this.isLoading = false
      await nextTick()
    },

    /**
     * @description bắt sự kiện click vào 1 thông báo
     * @author VDDung1
     */
    onClickItem (notify) {
      const me = this
      me.$emit('onClickNotifyItem')
      if (
        notify?.Type === me.$enumeration.NotifyType.StudentJoinNewClass ||
        notify?.Type === me.$enumeration.NotifyType.StudentJoinOldClass
      ) {
        me.showDetail(me.studentJoinNewClass, notify)
      }
    },

    /**
     * @author PVThang
     * @description Show popup thông báo cho học sinh khi bị từ chối/xóa khỏi lớp
     */
    async showPopupJoinClassFail (message) {
      const me = this

      me.$message.show({
        message: message,
        confirmButtonText: me.$t('Button.Agree'),
        showCancelButton: false,
        showIgnoreButton: false,
        dangerouslyUseHTMLString: true,
        callback: () => {}
      })
    },

    /**
     * @author PVThang
     * @description Load dữ liệu
     */
    async loadNotifyData (countNotifiesUnPreview = true) {
      const me = this

      me.showMask()
      const notifies = await me.getNotify({
        PageIndex: me.pageIndex,
        PageSize: me.pageSize,
        IsSetNumberUnPreview: countNotifiesUnPreview
      })
      if (me.notUseCommonData) {
        me.notifyItems = [...me.notifyItems, ...notifies]
      }
      if (notifies?.length < me.pageSize) {
        me.isLastPage = true
      } else {
        me.isLastPage = false
      }
      // countNotifiesUnPreview && (await me.countNotifyUnPreview())
      await nextTick()
      await me.hideMask()
      me.$refs.scrollbar?.update()
    },

    /**
     * @author PVThang
     * @description Xử lý sự kiện scroll
     * load data khi scroll đến cuối danh sách
     */
    async onScroll ({ clientHeight, scrollHeight, scrollTop }) {
      const me = this
      const isLoadData = scrollHeight - clientHeight <= scrollTop

      if (isLoadData && !me.isLastPage && !me.isLoading) {
        ++me.pageIndex
        await me.loadNotifyData(false)
      }
    },

    /**
     * @author PVThang
     * @description Khởi tạo dữ liệu
     */
    async initData () {
      const me = this

      me.pageIndex = 1
      me.notifyIsClicked = {}
      me.setNotifies([])
      await me.loadNotifyData()
    }
  },

  async created () {
    const me = this

    me.autoLoadData && (await me.initData())
  }
}
</script>

<style lang="scss" scoped>
.popover-content {
  margin: -12px;
  height: auto;
  max-height: 600px;
  @include overflow();
  display: grid;
  grid-template-columns: 100%;
  border-radius: 10px;
  overflow: hidden;

  :deep(.el-select-dropdown__wrap) {
    height: auto;
    max-height: 600px;
  }

  :deep(.el-select-dropdown__list) {
    padding: 0;
  }

  .is-empty {
    height: 300px;
  }
}
</style>
